<footer>
  <div class="copy text-center">
    <small class="font-size-smallest text-lightgray">© 2024 Copyright - SchoolAdvisor.com.br</small>
  </div>
</footer>
